import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const SellerRegList = () => {
  const [sellers, setSellers] = useState([]);
  const [sortedSellers, setSortedSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [approvingId, setApprovingId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchSellers();
  }, []);

  const fetchSellers = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_seller_registration"
      );
      const result = await response.json();

      if (result.status  && result.data) {
        setSellers(result.data);
        setSortedSellers(result.data);
      } else {
        setError("No seller data found");
      }
    } catch (err) {
      setError("Failed to fetch seller data");
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     ADMIN APPROVAL HANDLER
  ========================= */
  const handleApproveSeller = async (seller_id) => {
  const confirmApprove = window.confirm(
    "Are you sure you want to approve this seller?"
  );
  if (!confirmApprove) return;

  try {
    setApprovingId(seller_id);

    const formData = new FormData();
    formData.append("seller_id", seller_id);
    formData.append("admin_approval", "yes");

    const response = await fetch(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_seller_registration",
      {
        method: "POST",
        body: formData,
      }
    );

    const result = await response.json();
    console.log("Approve response:", result);

    if (result.status === true || result.success === "1") {
      const updatedList = sortedSellers.map((seller) =>
        seller.seller_id === seller_id
          ? { ...seller, admin_approval: "yes" }
          : seller
      );

      setSortedSellers(updatedList);
      setSellers(updatedList);
      alert("Seller approved successfully");
    } else {
      alert(result.message || "Failed to approve seller");
    }
  } catch (error) {
    console.error(error);
    alert("Something went wrong");
  } finally {
    setApprovingId(null);
  }
};


  /* Pagination */
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentSellers = sortedSellers.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(sortedSellers.length / itemsPerPage);

  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleNext = () =>
    currentPage < totalPages && setCurrentPage(currentPage + 1);

  const getPageNumbers = () => {
    const pages = [];
    let start = Math.max(1, currentPage - 1);
    let end = Math.min(totalPages, currentPage + 1);
    if (currentPage === 1) end = Math.min(3, totalPages);
    if (currentPage === totalPages) start = Math.max(totalPages - 2, 1);
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  return (
    <div className="page-content">
      <div className="container-fluid">

        <div className="row">
          <div className="col-12">
            <h4 className="mb-3 fw-semibold">Seller Registration List</h4>
          </div>
        </div>

        <div className="card">
          <div className="card-body p-0">

            {loading ? (
              <div className="text-center p-5">
                <div className="spinner-border text-primary" />
              </div>
            ) : error ? (
              <div className="alert alert-danger m-3">{error}</div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th>ID</th>
                      <th>Business</th>
                      <th>Owner</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Category</th>
                      <th>Status</th>
                      <th>Admin Approval</th>
                      <th>Created At</th>
                      <th>Admin Approval</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentSellers.map((seller) => (
                      <tr key={seller.seller_id}>
                        <td>#{seller.seller_id}</td>
                        <td>{seller.business_name}</td>
                        <td>{seller.owner_name}</td>
                        <td>{seller.email}</td>
                        <td>{seller.mobile}</td>
                        <td>{seller.business_category}</td>

                        <td>
                          <span className="badge bg-warning">
                            {seller.status}
                          </span>
                        </td>

                        <td>
                          <td>
                          {seller.admin_approval === "yes" ? (
                            <span className="badge bg-success">Approved</span>
                          ) : (
                            <span className="badge bg-warning">Pending</span>
                          )}
                        </td>

                        </td>

                        <td>{seller.created_at}</td>

                        <td>
                          {seller.admin_approval !== "yes" ? (
                            <button
                              className="btn btn-sm btn-success"
                              disabled={approvingId === seller.seller_id}
                              onClick={() => handleApproveSeller(seller.seller_id)}
                            >
                              {approvingId === seller.seller_id ? "Approving..." : "Approve"}
                            </button>
                          ) : (
                            <button className="btn btn-sm btn-secondary" disabled>
                              Approved
                            </button>
                          )}
                        </td>
                        <td>
                          <Link
                                    to={`/seller-view/${seller.seller_id}`}
                                    className="btn btn-soft-primary btn-sm ms-2"
                                  >
                                    <i className="fa-solid fa-eye"></i>
                                  </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Pagination */}
          <div className="card-footer">
            <ul className="pagination justify-content-end mb-0">
              <li className={`page-item ${currentPage === 1 && "disabled"}`}>
                <button className="page-link" onClick={handlePrev}>
                  Previous
                </button>
              </li>

              {getPageNumbers().map((page) => (
                <li
                  key={page}
                  className={`page-item ${
                    currentPage === page && "active"
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </button>
                </li>
              ))}

              <li
                className={`page-item ${
                  currentPage === totalPages && "disabled"
                }`}
              >
                <button className="page-link" onClick={handleNext}>
                  Next
                </button>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SellerRegList;
